module.exports = __webpack_public_path__ + "static/media/1POLICY35.e4265640.jpg";